import type { FC } from 'react'
import React from 'react'

import { getDataSelector } from '@vfuk/core-base-props'

import FieldWrapper from '@vfuk/core-field-wrapper'
import SelectInput from '@vfuk/core-select-input'

import * as Styled from './styles/SelectInputWithLabel.style'

import type { SelectInputWithLabelProps } from './SelectInputWithLabel.types'

const SelectInputWithLabel: FC<SelectInputWithLabelProps> = ({
  id,
  dataAttributes,
  state,
  fieldWrapper,
  selectInput,
  dataSelectorPrefix,
}) => {
  const componentName = 'SelectInputWithLabel'
  return (
    <Styled.Container id={id} {...dataAttributes} data-selector={getDataSelector(dataSelectorPrefix)} data-component-name={componentName}>
      <FieldWrapper
        state={state}
        helpText={fieldWrapper.helpText}
        label={fieldWrapper.label}
        formElementId={selectInput.id}
        showLabel={fieldWrapper.showLabel}
        subText={fieldWrapper.subText}
        stateText={fieldWrapper.stateText}
        validateOn={fieldWrapper.validateOn}
        width={fieldWrapper.width}
        helpLink={fieldWrapper.helpLink}
        optional={fieldWrapper.optional}
        required={fieldWrapper.required}
        dataSelectorPrefix={getDataSelector(dataSelectorPrefix, 'field-wrapper')}
      >
        <SelectInput
          state={state!}
          id={selectInput.id}
          name={selectInput.name}
          onBlur={selectInput.onBlur}
          onChange={selectInput.onChange}
          options={selectInput.options}
          placeholder={selectInput.placeholder}
          required={selectInput.required}
          value={selectInput.value}
          dataAttributes={selectInput.dataAttributes}
          domRef={selectInput.domRef}
          dataSelectorPrefix={getDataSelector(dataSelectorPrefix, 'select-input')}
        />
      </FieldWrapper>
    </Styled.Container>
  )
}

export default SelectInputWithLabel
